import StoreGettersService from '@/store/services/StoreGettersService';
import { Getters } from '@/store/enums/GettersEnums';
import { useStore } from 'vuex';

export default class GeneralDispatcherService extends StoreGettersService{

  constructor (store = useStore()) {super(store);}

  public getValidatedVersion() {
    return this.getValidatedGetter(Getters.GET_VERSION);
  }

  public getValidatedIsBuild() {
    return this.getValidatedGetter(Getters.GET_IS_BUILD);
  }
}
